// eslint-disable-next-line @typescript-eslint/no-unused-vars
function startTrace(_traceName: string): Promise<void> {
  return Promise.resolve();
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function stopTrace(_traceName: string): Promise<void> {
  return Promise.resolve();
}

export default {startTrace, stopTrace};
